import React, { Suspense } from 'react';
import { AuthCheckAdmin } from '../../Utils/AuthCheck/AdminCheck.auth';
import { FormContainer } from '../CreateRoutes/CreateForm.styles';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
const BreadCrumbs = React.lazy(
  () => import('../../Components/Breadcrumbs/BreadcrumbsComponent.component')
);
import NewsletterSubscribersDataProvider from '../../Utils/Newsletters/NewsletterSubscribersDataProvider';

const NewsletterSubscribersList = () => {
  return (
    <AuthCheckAdmin>
      <HelmetHelper
        title="Create Company"
        description="Form to create a company"
      />
      <FormContainer>
        <Suspense fallback={<p>Loading breadcrumbs...</p>}>
          <BreadCrumbs
            one="Admin Dashboard"
            oneLink="/admin"
            two={'Newsletter Subscribers'}
          />
        </Suspense>
        <h2>Newsletter Subscribers List</h2>
        <NewsletterSubscribersDataProvider>
          {(newslettersSubscribers) => (
            <main>
              {newslettersSubscribers?.map((s) => {
                return (
                  <div key={s?._id}>
                    <p>{s?.email}</p>
                  </div>
                );
              })}
            </main>
          )}
        </NewsletterSubscribersDataProvider>
      </FormContainer>
    </AuthCheckAdmin>
  );
};

export default NewsletterSubscribersList;
